let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Mz5o")).then(() => parcelRequire('c7sZn'));